<template>
  <div class="relative right-0 h-full flex flex-col">
    <div id="photoshop-container" class="w-full h-full flex flex-col">
      <!-- Photoshop Content Area -->
      <div class="photoshop-content">
        <iframe 
          ref="photoshopFrame"
          src="https://www.photopea.com/" 
          class="photoshop-frame"
          frameborder="0"
          allowfullscreen
        ></iframe>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue'

const photoshopFrame = ref(null)

onMounted(() => {
  // Inject CSS
  const style = document.createElement('style')
  style.textContent = `
    #photoshop-container {
      font-family: 'Roboto', sans-serif;
      background: #2c2c2c;
      display: flex;
      flex-direction: column;
      overflow: hidden;
    }
    
    #photoshop-container .photoshop-content {
      flex: 1;
      overflow: hidden;
      position: relative;
      width: 100%;
      height: 100%;
    }
    
    #photoshop-container .photoshop-frame {
      width: 100%;
      height: 100%;
      border: none;
      display: block;
    }
  `
  document.head.appendChild(style)
})
</script>

